var site = site || {};

(function ($) {
  Drupal.behaviors.aerinFragranceFinderResultV1 = {
    productsArray: page_data['custom-mpp'].products || [],
    attach: function (context) {
      var self = this;
      var $modules = $('.js-aerin-fragrance-finder-result', context);

      $modules.each(function () {
        var $module = $(this);
        var $products = $module.find('.js-aerin-fragrance-finder-result-product');
        var isNonShoppable = $module
          .closest('.js-aerin-fragrance-finder-formatter')
          .hasClass('js-non-shoppable');

        $products.each(function () {
          var $product = $(this);

          self.getDom($product);
          self.setConfig($product);
          if (isNonShoppable) {
            self.removeShoppableElements($product);
          } else {
            self.qsInit($product);
          }
          self.setListeners($product);
        });
      });
    },
    removeShoppableElements: function ($product) {
      $.each($product.nodes.shoppable, function () {
        $(this).remove();
      });
    },
    qsInit: function ($product) {
      var isMobile =
        parseInt(Unison.fetch.now().width, 10) === parseInt(Unison.fetch.all().small, 10);

      if (isMobile) {
        return;
      }
      if (typeof site.product !== 'undefined' && typeof site.product.view !== 'undefined') {
        if (typeof site.product.view.equalRowHeight !== 'undefined') {
          site.product.view.equalRowHeight($product);
        }
        if (typeof site.product.view.brief !== 'undefined') {
          site.product.view.brief({
            containerNode: $product.get(0),
            productData: $product.config.productData
          });
        }
      }
    },
    updateProductImage: function ($product, imgUrl) {
      if (imgUrl) {
        $product.nodes.image.attr('src', imgUrl);
      }
    },
    setListeners: function ($product) {
      var self = this;
      var $sku;

      $product.nodes.selected.once().on('click', function () {
        $product.nodes.skus.toggleClass('active');
      });
      $product.nodes.skus
        .find('.js-aerin-fragrance-finder-result-product-sku')
        .once()
        .on('click', function () {
          $sku = $(this);
          $product.nodes.selected.html($sku.html());
          $product.nodes.skus.removeClass('active');
          $product.nodes.skus
            .siblings('.js-add-to-cart')
            .attr('data-sku-base-id', $sku.data('skuId'));
          $product.nodes.price.html($sku.data('skuPrice'));
          self.updateProductImage($product, $sku.data('productImg'));
        });
      $product.nodes.qsLink
        .once()
        .off()
        .on('click', function (e) {
          e.preventDefault();
          site.quickshop($product.config.productData);
        });
      $(window).resize(
        _.debounce(function () {
          self.qsInit($product);
        }, 250)
      );
    },
    setConfig: function ($product) {
      $product.config = {};
      $product.config.productData = _.find(self.productsArray, function (p) {
        return p.PRODUCT_ID === $product.data('productId');
      });
    },
    getDom: function ($product) {
      $product.nodes = {};
      $product.nodes.image = $('.js-aerin-fragrance-finder-result__product-image', $product);
      $product.nodes.qsLink = $('.js-qs-link', $product);
      $product.nodes.skus = $('.js-aerin-fragrance-finder-result-product-skus', $product);
      $product.nodes.selected = $(
        '.js-aerin-fragrance-finder-result-product-skus--selected',
        $product.nodes.skus
      );
      $product.nodes.price = $product.nodes.skus
        .siblings('.js-aerin-fragrance-finder-result-product-content')
        .find('.js-aerin-fragrance-finder-result-product-content--price');
      $product.nodes.atb = $('.js-aerin-fragrance-finder-result-product-atb', $product);
      $product.nodes.shoppable = [
        $product.nodes.price,
        $product.siblings('.js-aerin-fragrance-finder-result-products-link'),
        $product.nodes.atb
      ];
    }
  };
})(jQuery);
